import {CallProcessing} from 'call_processing/call_processing'
window.CallProcessing = CallProcessing;

import {CallProcessorEditor} from 'call_processing/call_processor_editor'
window.CallProcessorEditor = CallProcessorEditor;